import { useQuery } from '@tanstack/react-query'
import { ApiClient } from '../api'

// useResourcesDirectory — read-on-mount fetch of the cross-event
// matrix (spec 46). No polling — the page refreshes when the user
// navigates back. 5-minute staleTime so a quick "go to event, come
// back" round-trip is a cache hit; explicit invalidate from the
// per-event ResourcesPanel mutations would refresh it sooner but
// isn't wired here yet.

export function useResourcesDirectory() {
  return useQuery({
    queryKey: ['resources-directory'],
    queryFn: ApiClient.resourcesDirectory,
    staleTime: 5 * 60_000
  })
}
